import React from "react";
import SystemSettings from "../../components/system-settings/SystemSettings";
import { SYSTEM_CONFIGURATION_TABS } from "../../utils/AppEnumerations";

const SystemConfigurations = () => {
  return <SystemSettings menuId={SYSTEM_CONFIGURATION_TABS.SystemSettings} />;
};

export default SystemConfigurations;
